(ns net.kestec.re-frame.event
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx
 ::fx
 (fn [{db :db} [_ f-or-fx & fargs]]
   (if (fn? f-or-fx)
     (apply f-or-fx db fargs)
     (do #_(assert (nil? fargs) (str "Cannot pass args to plain fx map " (pr-str fargs)))
      (js/console.debug "Discarding args for literal fx map" fargs)
         f-or-fx))))

(defn target-value [event]
  (.. ^js event -target -value))

(defn handler
  ([event] (handler event target-value))
  ([event map-argument]
   (when (seq event)
     (let [ev (vec event)]
       (fn [e & args]
         (when e
           (.preventDefault e))
         (rf/dispatch (-> ev
                          (conj (map-argument e))
                          (into args))))))))

(defn dispatch [event & event-args]
  (when event
    (rf/dispatch
     (into (vec event)
           event-args))))

(rf/reg-event-fx
 ::log
 (fn [_ [_ logger & message]]
   {::log {:logger   (case logger
                       (:log :success) js/console.log
                       :debug js/console.debug
                       :info js/console.info
                       :warning js/console.warn
                       :error js/console.error)
           :messages message}}))

(rf/reg-fx
 ::log
 (fn [{:keys [logger messages]}]
   (apply logger messages)))
